import ReplySuggestions from './ReplySuggestions.component';

export default ReplySuggestions;
